import { Grid } from '@statsbomb/kitbag-components';
import { useSetAtom } from 'jotai';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { selectedSourceDataAtom } from '../../atoms/selectedSourceData';
import SelectSourceName from './SelectSourceName';
import SelectSourceType from './SelectSourceType';
import SelectUploadMethod from './SelectUploadMethod';
import { DEFAULT_UPLOAD_METHOD, VIA_URL_TRANSCODED } from './sourceOptions';

export function SelectSource({ sport, urlWithTranscodeOnly }) {
  const setSourceData = useSetAtom(selectedSourceDataAtom);

  useEffect(() => {
    setSourceData({
      requiresTranscoding: false,
      uploadMethod: urlWithTranscodeOnly
        ? VIA_URL_TRANSCODED.id
        : DEFAULT_UPLOAD_METHOD.id,
    });
  }, []);

  return (
    <div data-testid="source-selection">
      <Grid>
        {!urlWithTranscodeOnly && (
          <Grid item xs={4}>
            <SelectUploadMethod />
          </Grid>
        )}
        <Grid item xs={urlWithTranscodeOnly ? 6 : 4}>
          <SelectSourceType />
        </Grid>
        <Grid item xs={urlWithTranscodeOnly ? 6 : 4}>
          <SelectSourceName sport={sport} />
        </Grid>
      </Grid>
    </div>
  );
}

SelectSource.propTypes = {
  sport: PropTypes.string.isRequired,
  urlWithTranscodeOnly: PropTypes.bool,
};
SelectSource.defaultProps = {
  urlWithTranscodeOnly: false,
};

export default { SelectSource };
